export const capitalToCamel = (input: string): string => {
  return input
    .toLowerCase() // make everything lowercase
    .split("_") // split by underscores
    .map(
      (word, index) =>
        index === 0
          ? word // first word stays lowercase
          : word.charAt(0).toUpperCase() + word.slice(1) // capitalize subsequent words
    )
    .join(""); // join back together
};
